import { render, staticRenderFns } from "./CrewBasicInfoCard.vue?vue&type=template&id=43ae0e51"
import script from "./CrewBasicInfoCard.vue?vue&type=script&lang=js"
export * from "./CrewBasicInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports